export enum ParmedFooter {
    InquiryId = 'info@parmedpharm.com',
    InquiryNumber = '800.727.6331',
    SupportId = '',
    SupportNumber = '',
    WeekWorkingTime = 'Monday – Friday 9:00 a.m. to 9:00 p.m. EST',
    WeekendWorkingTime = 'Saturday 10 a.m. – 3:30 p.m.',
    Copyright = 'ParMed Pharmaceuticals. All rights reserved.',
    SiteName = 'www.parmed.com',
    Address1 = '5960 E Shelby Dr, Suite 100',
    Address2 = 'Memphis, TN 38141-7602',
    backOrderMsg = ''
};